import { http } from 'interfaces'
import { type LutValues } from 'services'
import { SerializableMap } from 'components'

interface Branch {
  branch_desc: string
  id: number
}
export interface RoleRef {
  id: number
}
export interface Role extends RoleRef {
  desc: string
  branch: Branch
  code: string | null
}
export interface UsRoleLutValues extends LutValues {
  roles: Map<number, Role>
}

export async function getRoles (): Promise<UsRoleLutValues> {
  const response = await http.get('api/v1/us/role/lut/')
  return { ...response.data, roles: new SerializableMap(response.data.roles.map((role: Role) => [role.id, role])) }
}
